import * as React from "react";
import "Styles/Pages/howitworkslp.scss";
import initHeroAnimation from "./initHeroAnimation";
import FAQSection from "./FAQSection";
import assertContainerElement from "Utils/assertContainerElement";
import { render } from "react-dom";

initHeroAnimation();

const root = document.getElementById("hiwlp-faq");
assertContainerElement(root);
render(<FAQSection />, root);